module.exports = __webpack_public_path__ + "static/media/kayakdos.532ff504.png";